import module from 'viaticos/module.js'

export const schemaSolicitud = {
  solicitud_id: 'number',
  importe: 'number',
  propina: 'number',
  total: 'number',
  autorizado: 'boolean',
  cancelado: 'boolean',
  maquilado: 'boolean',
  eliminado: 'boolean',
  pagado: 'boolean',
  timbrado: 'boolean',
  preautorizado: 'boolean',
  fecha: 'datetime',
  indice: 'number',
  editable: 'boolean',
  eliminable: 'boolean',
  tipo_id: 'number',
  ultimo: 'boolean',
  acceso_autorizar: 'boolean',
  acceso_maquilar: 'boolean',
  acceso_proyecto: 'boolean',
  acceso_solicitar: 'boolean',
  acceso_eliminar: 'boolean',
  autorizaciones: {
    fecha_autorizacion: 'datetime',
    correo_enviado_fecha: 'date',
    autorizado: 'boolean',
    cancelado: 'boolean',
    correo_enviado: 'boolean',
    indice: 'number',
    maximo: 'number',
    posicion: 'number',
    usuario_id: 'number',
    tipo_id: 'number',
  },
  comprobantes: {
    comprobante_id: 'number',
    deducible: 'boolean',
    fecha: 'date',
    moneda_id: 'number',
    subtotal: 'number',
    tipo_cambio: 'number',
    propina: 'number',
    total: 'number',
    total_impuestos_trasladados: 'number',
    total_impuestos_retenidos: 'number',
  },
}

export const schema = {
  tipo_id: 'number',
  mostrar_detalles: 'boolean',
  informacion: {
    acceso_solicitar: 'boolean',
    acceso_eliminar: 'boolean',
    autorizados: 'number',
    cerrado: 'boolean',
    diastolerancia: 'number',
    fecha_inicial: 'date',
    fecha_final: 'date',
    fecha_limite: 'date',
    personal: 'boolean',
  },
  viaje: {
    fecha_inicial: 'date',
    fecha_final: 'date',
    tipo_viaje_id: 'number',
  },
  solicitudes: {
    anticipos: schemaSolicitud,
    comprobaciones: schemaSolicitud,
    devoluciones: schemaSolicitud,
    reembolsos: schemaSolicitud,
  },
  resumen: {
    anticipos: 'number',
    comprobaciones: 'number',
    devoluciones: 'number',
    reembolsos: 'number',
    saldo: 'number',
  },
}

export class ViaticosMaquilarService {
  constructor ($http) {
    this.$http = $http
  }

  get (fechaInicial, fechaFinal) {
    return this.$http.get('api/viaticos/viaticos/maquilar', {
      params: {
        fechaInicial: fechaInicial ? fechaInicial.toYMD() : fechaInicial,
        fechaFinal: fechaFinal.toYMD(),
      },
      schema,
    })
  }

  post (solicitudId, viaticoId, data) {
    return this.$http.post('api/viaticos/viaticos/maquilar', data, {
      params: {
        solicitud_id: solicitudId,
        viatico_id: viaticoId,
      },
    })
  }

  delete (idNomina, idProyecto, solicitudId) {
    return this.$http.delete('api/viaticos/viaticos/maquilar', {
      params: {
        id_nomina: idNomina,
        id_proyecto: idProyecto,
        solicitud_id: solicitudId,
      },
      schema: schemaSolicitud,
    })
  }
}

module.service('ViaticosMaquilarService', ViaticosMaquilarService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Maquilar.js